"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var esr = __importStar(require("eosio-signing-request"));
var eosjs_1 = require("eosjs");
var ecc = __importStar(require("eosjs-ecc"));
var fetch_ponyfill_1 = __importDefault(require("fetch-ponyfill"));
var zlib = __importStar(require("pako"));
var v4_1 = __importDefault(require("uuid/v4"));
var ws_1 = __importDefault(require("ws"));
var errors_1 = require("./errors");
var link_options_1 = require("./link-options");
var link_session_1 = require("./link-session");
var utils_1 = require("./utils");
var fetch = fetch_ponyfill_1.default().fetch;
var Link = /** @class */ (function () {
    function Link(options) {
        this.abiCache = new Map();
        if (options.rpc === undefined || typeof options.rpc === 'string') {
            this.rpc = new eosjs_1.JsonRpc(options.rpc || link_options_1.defaults.rpc, { fetch: fetch });
        }
        else {
            this.rpc = options.rpc;
        }
        this.chainId = options.chainId || link_options_1.defaults.chainId;
        this.serviceAddress = (options.service || link_options_1.defaults.service).trim().replace(/\/$/, '');
        this.transport = options.transport;
        this.requestOptions = {
            abiProvider: this,
            textDecoder: options.textDecoder || new TextDecoder(),
            textEncoder: options.textEncoder || new TextEncoder(),
            zlib: zlib,
        };
    }
    Link.prototype.getAbi = function (account) {
        return __awaiter(this, void 0, void 0, function () {
            var rv;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        rv = this.abiCache.get(account);
                        if (!!rv) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.rpc.get_abi(account)];
                    case 1:
                        rv = (_a.sent()).abi;
                        if (rv) {
                            this.abiCache.set(account, rv);
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/, rv];
                }
            });
        });
    };
    Link.prototype.createCallbackUrl = function () {
        return this.serviceAddress + "/" + v4_1.default();
    };
    Link.prototype.createRequest = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            var request;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, esr.SigningRequest.create(__assign(__assign({}, args), { chainId: this.chainId, broadcast: false, callback: {
                                url: this.createCallbackUrl(),
                                background: true,
                            } }), this.requestOptions)];
                    case 1:
                        request = _a.sent();
                        return [2 /*return*/, request];
                }
            });
        });
    };
    Link.prototype.sendRequest = function (request, transport) {
        return __awaiter(this, void 0, void 0, function () {
            var t, linkUrl, ctx_1, socket, cancel, payload_1, signer, signatures, resolved, serializedTransaction, transaction, result, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        t = transport || this.transport;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        linkUrl = request.data.callback;
                        if (!linkUrl.startsWith(this.serviceAddress)) {
                            throw new Error('Request must have a link callback');
                        }
                        if (request.data.flags !== 2) {
                            throw new Error('Invalid request flags');
                        }
                        ctx_1 = {};
                        socket = waitForCallback(linkUrl, ctx_1);
                        cancel = new Promise(function (resolve, reject) {
                            t.onRequest(request, function (reason) {
                                if (ctx_1.cancel) {
                                    ctx_1.cancel();
                                }
                                if (typeof reason === 'string') {
                                    reject(new errors_1.CancelError(reason));
                                }
                                else {
                                    reject(reason);
                                }
                            });
                        });
                        return [4 /*yield*/, Promise.race([socket, cancel])];
                    case 2:
                        payload_1 = _a.sent();
                        signer = {
                            actor: payload_1.sa,
                            permission: payload_1.sp,
                        };
                        signatures = Object.keys(payload_1)
                            .filter(function (key) { return key.startsWith('sig') && key !== 'sig0'; })
                            .map(function (key) { return payload_1[key]; });
                        return [4 /*yield*/, esr.ResolvedSigningRequest.fromPayload(payload_1, this.requestOptions)];
                    case 3:
                        resolved = _a.sent();
                        serializedTransaction = resolved.serializedTransaction, transaction = resolved.transaction;
                        result = {
                            request: request,
                            serializedTransaction: serializedTransaction,
                            transaction: transaction,
                            signatures: signatures,
                            payload: payload_1,
                            signer: signer,
                        };
                        if (t.onSuccess) {
                            t.onSuccess(request, result);
                        }
                        return [2 /*return*/, result];
                    case 4:
                        error_1 = _a.sent();
                        if (t.onFailure) {
                            t.onFailure(request, error_1);
                        }
                        throw error_1;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    Link.prototype.transact = function (args, transport) {
        return __awaiter(this, void 0, void 0, function () {
            var t, request, result, broadcast, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        t = transport || this.transport;
                        return [4 /*yield*/, this.createRequest(args)];
                    case 1:
                        request = _a.sent();
                        return [4 /*yield*/, this.sendRequest(request, t)
                            // broadcast transaction if requested
                        ];
                    case 2:
                        result = _a.sent();
                        broadcast = args.broadcast || false;
                        if (!broadcast) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.rpc.push_transaction({
                                signatures: result.signatures,
                                serializedTransaction: result.serializedTransaction,
                            })];
                    case 3:
                        res = _a.sent();
                        result.processed = res.processed;
                        _a.label = 4;
                    case 4: return [2 /*return*/, result];
                }
            });
        });
    };
    /**
     * Create a identity request.
     * @param requestPermission Optional request permission if the request is for a specific account or permission.
     * @param info Metadata to add to the request.
     */
    Link.prototype.identify = function (requestPermission, info) {
        return __awaiter(this, void 0, void 0, function () {
            var request, res, serializedTransaction, message, signer, signerKey, account, permission, auth, keyAuth;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createRequest({
                            identity: { permission: requestPermission },
                            info: info,
                        })];
                    case 1:
                        request = _a.sent();
                        return [4 /*yield*/, this.sendRequest(request)];
                    case 2:
                        res = _a.sent();
                        return [4 /*yield*/, esr.ResolvedSigningRequest.fromPayload(res.payload, this.requestOptions)];
                    case 3:
                        serializedTransaction = (_a.sent()).serializedTransaction;
                        message = Buffer.concat([
                            Buffer.from(request.getChainId(), 'hex'),
                            Buffer.from(serializedTransaction),
                            Buffer.alloc(32),
                        ]);
                        signer = res.signer;
                        signerKey = ecc.recover(res.signatures[0], message);
                        return [4 /*yield*/, this.rpc.get_account(signer.actor)];
                    case 4:
                        account = _a.sent();
                        if (!account) {
                            throw new errors_1.IdentityError("Signature from unknown account: " + signer.actor);
                        }
                        permission = account.permissions.find(function (_a) {
                            var perm_name = _a.perm_name;
                            return perm_name === signer.permission;
                        });
                        if (!permission) {
                            throw new errors_1.IdentityError(signer.actor + " signed for unknown permission: " + signer.permission);
                        }
                        auth = permission.required_auth;
                        keyAuth = auth.keys.find(function (_a) {
                            var key = _a.key;
                            return key === signerKey;
                        });
                        if (!keyAuth) {
                            throw new errors_1.IdentityError(signer.actor + "@" + signer.permission + " has no key matching id signature");
                        }
                        if (auth.threshold > keyAuth.weight) {
                            throw new errors_1.IdentityError(signer.actor + "@" + signer.permission + " signature does not reach auth threshold");
                        }
                        return [2 /*return*/, __assign(__assign({}, res), { account: account,
                                signerKey: signerKey })];
                }
            });
        });
    };
    /**
     * Login and create a persistent session.
     */
    Link.prototype.login = function (sessionName) {
        return __awaiter(this, void 0, void 0, function () {
            var privateKey, requestKey, createInfo, res, session;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ecc.randomKey()];
                    case 1:
                        privateKey = _a.sent();
                        requestKey = ecc.privateToPublic(privateKey);
                        createInfo = {
                            session_name: sessionName,
                            request_key: requestKey,
                        };
                        return [4 /*yield*/, this.identify(undefined, {
                                link: utils_1.abiEncode(createInfo, 'link_create'),
                            })];
                    case 2:
                        res = _a.sent();
                        if (res.payload.link_ch && res.payload.link_key && res.payload.link_name) {
                            session = new link_session_1.LinkChannelSession(this, {
                                auth: res.signer,
                                publicKey: res.signerKey,
                                channel: {
                                    url: res.payload.link_ch,
                                    key: res.payload.link_key,
                                    name: res.payload.link_name,
                                },
                                requestKey: privateKey,
                            });
                        }
                        else {
                            session = new link_session_1.LinkFallbackSession(this, {
                                auth: res.signer,
                                publicKey: res.signerKey,
                            });
                        }
                        return [2 /*return*/, __assign(__assign({}, res), { session: session })];
                }
            });
        });
    };
    /**
     * Create an eosjs signature provider using this link.
     * Note that we don't know what keys are available so those have to be provided.
     */
    Link.prototype.makeSignatureProvider = function (availableKeys, transport) {
        var _this = this;
        return {
            getAvailableKeys: function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                return [2 /*return*/, availableKeys];
            }); }); },
            sign: function (args) { return __awaiter(_this, void 0, void 0, function () {
                var request, signatures;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            request = esr.SigningRequest.fromTransaction(args.chainId, args.serializedTransaction, this.requestOptions);
                            request.setCallback(this.createCallbackUrl(), true);
                            request.setBroadcast(false);
                            return [4 /*yield*/, this.sendRequest(request, transport)];
                        case 1:
                            signatures = (_a.sent()).signatures;
                            return [2 /*return*/, __assign(__assign({}, args), { signatures: signatures })];
                    }
                });
            }); },
        };
    };
    return Link;
}());
exports.Link = Link;
function waitForCallback(url, ctx) {
    return new Promise(function (resolve, reject) {
        var active = true;
        var retries = 0;
        var socketUrl = url.replace(/^http/, 'ws');
        var handleResponse = function (response) {
            try {
                resolve(JSON.parse(response));
            }
            catch (error) {
                error.message = 'Unable to parse callback JSON: ' + error.message;
                reject(error);
            }
        };
        var connect = function () {
            var socket = new ws_1.default(socketUrl);
            ctx.cancel = function () {
                active = false;
                if (socket.readyState === ws_1.default.OPEN ||
                    socket.readyState === ws_1.default.CONNECTING) {
                    socket.close();
                }
            };
            socket.onmessage = function (event) {
                active = false;
                if (socket.readyState === ws_1.default.OPEN) {
                    socket.close();
                }
                if (typeof Blob !== 'undefined' && event.data instanceof Blob) {
                    var reader_1 = new FileReader();
                    reader_1.onload = function () {
                        handleResponse(reader_1.result);
                    };
                    reader_1.onerror = function (error) {
                        reject(error);
                    };
                    reader_1.readAsText(event.data);
                }
                else {
                    if (typeof event.data === 'string') {
                        handleResponse(event.data);
                    }
                    else {
                        handleResponse(event.data.toString());
                    }
                }
            };
            socket.onopen = function () {
                retries = 0;
            };
            socket.onerror = function (error) { };
            socket.onclose = function (close) {
                if (active) {
                    setTimeout(connect, backoff(retries++));
                }
            };
        };
        connect();
    });
}
/**
 * Exponential backoff function that caps off at 10s after 10 tries.
 * https://i.imgur.com/IrUDcJp.png
 */
function backoff(tries) {
    return Math.min(Math.pow(tries * 10, 2), 10 * 1000);
}
//# sourceMappingURL=link.js.map